import Vue from 'vue'
import Vuex from 'vuex'
import { login, get } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/token'
import { get as getConfig } from '@/api/config'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: getToken(),
    isLogin: false,
    info: undefined,
    config: {}
  },
  mutations: {
    login: (state, token) => {
      state.token = token
      setToken(token)
    },
    info: (state, info) => {
      state.isLogin = true
      state.info = info
    },
    logout: (state) => {
      state.isLogin = false
      state.info = undefined
      state.token = undefined
      removeToken()
    },
    setConfig: (state, config) => {
      state.config = config
    }
  },
  actions: {
    Login ({commit}, data) {
      return new Promise((resolve, reject) => {
        login(data).then(response => {
          const data = response.data
          if (response.code === 0) {
            setToken(data.token)
            commit('login', data.token)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserInfo ({commit}) {
      return new Promise((resolve, reject) => {
        get().then(response => {
          const user = response.data
          if (response.code === 0) {
            if (((user.role & 2) || (user.role & 4) || (user.role & 8)) && user.school) { // 学校用户、专家用户、上级管理部门
              commit('info', user)
              resolve(response)
            } else {
              commit('logout')
              reject(response)
            }
          } else {
            commit('logout')
            reject(response)
          }
        }).catch(err => {
          commit('logout')
          reject(err)
        })
      })
    },
    Logout ({commit}) {
      return new Promise(resolve => {
        commit('logout')
        resolve()
      })
    },
    GetConfig({commit}) {
      return new Promise((resolve, reject) => {
        getConfig(process.env.CMS_CONFIG_ID).then(response => {
          const data = response.data
          if (response.code === 0) {
            commit('setConfig', data)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js